module.exports = __webpack_public_path__ + "media/images/products/discovery-retailers-landing-26cc2a4e47d2a770b59a3aee51a71b00.jpg";